import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Store from '../../stores/Store'
import { FormDropdown } from 'semantic-ui-react'
import { observer } from 'mobx-react'

@observer
class Checkbox extends Component {
  static propTypes = {
    ...FormDropdown.propTypes,
    store: PropTypes.instanceOf(Store).isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    defaultValue: PropTypes.any,
    errorPointing: PropTypes.oneOf(['below', 'above', 'left']),
    castValue: PropTypes.func, // could be useful if you want to cast a value entered
    parseValue: PropTypes.func // could be useful if you want to parse value to form value
  }

  static defaultProps = {
    errorPointing: 'above'
  }

  handleOnChangeInput = (e, data) => {
    const { store, castValue } = this.props
    const value = castValue ? castValue(data.value) : data.value
    store.set(data.name, value)
    store.resetErrorMessageField(data.name)
  }

  render () {
    const {
      store,
      defaultValue,
      name,
      onChange,
      castValue,
      parseValue,
      errorPointing,
      error,
      ...props
    } = this.props
    const value = store.get(name, defaultValue || false)
    const valueError = store.getErrorMessageField(name)
    return (
      <FormDropdown
        value={parseValue ? parseValue(value) : value}
        name={name}
        error={valueError ? { content: valueError, pointing: errorPointing } : error}
        onChange={onChange || this.handleOnChangeInput}
        {...props}
      />
    )
  }
}
export default Checkbox
